import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SettingsContext = createContext(null);

// Sensible defaults so the UI never breaks if the fetch is slow
const DEFAULTS = {
  company_name: "Asiabest Group International Inc.",
  company_short_name: "Asiabest Group",
  company_suffix: "Holdings, Inc.",
  logo_letter: "A",
  tagline: "Patient capital. Principled operators. Enduring value.",
  stock_symbol: "PSE : ABG",
  stock_ticker: "ABG",
  listing_tagline: "Publicly Listed · Philippines",
  sec_registration: "SEC Registration No. AS094-009872",
  email_ir: "ir@asiabestgroup.ph",
  email_media: "media@asiabestgroup.ph",
  phone_main: "+63 2 8888 2026",
  phone_ir: "+63 2 8888 2030",
  address_line_1: "32F One Premier Tower",
  address_line_2: "26th St cor 4th Ave",
  address_line_3: "Bonifacio Global City, Taguig 1634",
  address_line_4: "Philippines",
  address_short: "32F One Premier Tower, Bonifacio Global City, Taguig 1634, Philippines",
  map_query: "Bonifacio Global City, Taguig, Philippines",
  footer_description: "A publicly listed Philippine holding company.",
  copyright_holder: "Asiabest Group International Inc.",
  media_kit_description: "Journalists, analysts, and shareholders can request our official media kit—logo files, executive headshots, brand guidelines, and downloadable press templates—directly by email. All interview and statement requests are routed through Corporate Affairs.",
  media_kit_email: "media@asiabestgroup.ph",
  spokesperson_info: "All media inquiries are handled by the Corporate Affairs office. For interview requests, please email media@asiabestgroup.ph with your outlet, the topic, and your deadline. We aim to respond within one business day.",
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings({ ...DEFAULTS, ...data });
    } catch (_) {
      setSettings(DEFAULTS);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  return (
    <SettingsContext.Provider value={{ settings, loading, refresh, setSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => {
  const ctx = useContext(SettingsContext);
  return ctx?.settings || DEFAULTS;
};

export const useSettingsContext = () => useContext(SettingsContext);
